import { V4 } from '../tokens';

interface DotsLoaderProps {
  size?: number;
  color?: string;
}

export function DotsLoader({ size = 6, color }: DotsLoaderProps) {
  const dotColor = color ?? V4.grayUltraDark;
  const gap = size * 0.7;

  return (
    <span
      aria-hidden="true"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap,
      }}
    >
      {[0, 120, 240].map((delay) => (
        <span
          key={delay}
          style={{
            width: size,
            height: size,
            borderRadius: '50%',
            background: dotColor,
            animation: 'plick-bounce 1.1s ease-in-out infinite',
            animationDelay: `${delay}ms`,
            display: 'inline-block',
          }}
        />
      ))}
    </span>
  );
}
